<header class="app-header">
    <!-- Logo -->
    <div class="header-section logo-section">
        <img src="../../assets/images/logo_big.png" alt="Logo" class="header-logo" />
    </div>

    <!-- Title -->
    <div class="header-section title-section">
        <div class="header-title">Emek Hafrashat Challah Davening List</div>
    </div>

    <!-- Menu -->
       <div class="header-section phone-menu-section menu-list" *ngIf="daveningService.showHeaderMenu">
            <a routerLink="admin" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"
               class="btn btn-menu phone-btn">Admin</a>
            <a routerLink="guest" routerLinkActive="active" class="btn btn-menu phone-btn">Guest</a>

        <div class="phone-logout" *ngIf="authService.adminLogin.email">
            <button class="btn btn-danger phone-logout-btn" (click)="logout()">Admin Logout</button>
        </div>
    </div>

    <ng-template #fill>
        <div class="header-section menu-section"></div>
    </ng-template>
</header>
